/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Import_As_MarkersInputs */

const en_ocr_import_as_markers = /** @type {(inputs: Ocr_Import_As_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import as Markers`)
};

const fr_ocr_import_as_markers = /** @type {(inputs: Ocr_Import_As_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer comme marqueurs`)
};

const de_ocr_import_as_markers = /** @type {(inputs: Ocr_Import_As_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Marker importieren`)
};

const it_ocr_import_as_markers = /** @type {(inputs: Ocr_Import_As_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa come marcatori`)
};

const ru_ocr_import_as_markers = /** @type {(inputs: Ocr_Import_As_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импортировать как маркеры`)
};

const es_ocr_import_as_markers = /** @type {(inputs: Ocr_Import_As_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar como marcadores`)
};

const zh_cn2_ocr_import_as_markers = /** @type {(inputs: Ocr_Import_As_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入为标记`)
};

const ja_ocr_import_as_markers = /** @type {(inputs: Ocr_Import_As_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーカーとしてインポート`)
};

const hi_ocr_import_as_markers = /** @type {(inputs: Ocr_Import_As_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मार्कर के रूप में आयात करें`)
};

const pt_pt2_ocr_import_as_markers = /** @type {(inputs: Ocr_Import_As_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar como marcadores`)
};

/**
* | output |
* | --- |
* | "Import as Markers" |
*
* @param {Ocr_Import_As_MarkersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_import_as_markers = /** @type {((inputs?: Ocr_Import_As_MarkersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Import_As_MarkersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_import_as_markers(inputs)
	if (locale === "de") return de_ocr_import_as_markers(inputs)
	if (locale === "it") return it_ocr_import_as_markers(inputs)
	if (locale === "ru") return ru_ocr_import_as_markers(inputs)
	if (locale === "es") return es_ocr_import_as_markers(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_import_as_markers(inputs)
	if (locale === "ja") return ja_ocr_import_as_markers(inputs)
	if (locale === "hi") return hi_ocr_import_as_markers(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_import_as_markers(inputs)
	return en_ocr_import_as_markers(inputs)
});